import React from 'react';

import Icon from '../Icon/Icon';

const DisclaimerIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g transform='translate(16 10)' fill='none' fillRule='evenodd'>
                <g transform='translate(2 10)'>
                    <circle cx='7.5' cy='7.5' r='6.5' stroke='#34303D' strokeWidth='2' />
                    <circle fill='#00D1D2' cx='7.5' cy='7.5' r='4.193' />
                    <path
                        d='m5.396 7.493.374.363a1 1 0 0 0 1.404-.01L9.55 5.467a.58.58 0 0 1 .802-.018.533.533 0 0 1 .016.77L7.186 9.397a1 1 0 0 1-1.415-.002L4.634 8.253a.534.534 0 0 1 .002-.755.542.542 0 0 1 .76-.005z'
                        fill='#34303D'
                    />
                </g>
                <g transform='translate(2 27)'>
                    <circle cx='7.5' cy='7.5' r='6.5' stroke='#34303D' strokeWidth='2' />
                    <circle fill='#00D1D2' cx='7.5' cy='7.5' r='4.193' />
                    <path
                        d='m5.396 7.493.374.363a1 1 0 0 0 1.404-.01L9.55 5.467a.58.58 0 0 1 .802-.018.533.533 0 0 1 .016.77L7.186 9.397a1 1 0 0 1-1.415-.002L4.634 8.253a.534.534 0 0 1 .002-.755.542.542 0 0 1 .76-.005z'
                        fill='#34303D'
                    />
                </g>
                <rect
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinejoin='round'
                    x='-1'
                    y='7'
                    width='34'
                    height='38'
                    rx='1'
                />
                <path
                    d='M24 3c.552 0 1.052.224 1.414.586.362.362.586.862.586 1.414v2H6V5c0-.552.224-1.052.586-1.414A1.994 1.994 0 0 1 8 3z'
                    stroke='#34303D'
                    strokeWidth='2'
                    fill='#00D1D2'
                    strokeLinejoin='round'
                />
                <path
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M21 32.5h7M21 15.5h7M21 36.5h7M21 19.5h7'
                />
                <path
                    d='M16-1c.77 0 1.488.36 2.03.9.626.628.97 1.469.97 2.1 0 .298-.077.643-.224.99a81.664 81.664 0 0 1-1.415.013h-.364l-.337-.001L15.624 3l-.785.005C12.9 1.664 13.267.703 13.818.01 14.298-.597 15.096-1 16-1z'
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinejoin='round'
                />
            </g>
        </Icon>
    );
};

export default DisclaimerIcon;
